import type { CouponTokens } from './types';

export const coupon: CouponTokens = {
  colors: {
    ticket: 'secondary.50',
    line: 'secondary.70',
    text: 'primary.90',
    money: 'primary.90',
  },
};
